<template>
  <div>
    <Breadcrumbs
      main-link="welcome"
      :main="$t('dashboardVue.dashboard')"
      :title="`Yeni ${requestType}`"
    />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <h3 class="mb-3">
        {{ $t('login.yeni') }}
        <span v-if="requestType==='PQ'">{{ $t('newRequestPopupContent.qiymtSorusu') }}</span>
        <span v-else-if="requestType==='PQT'">{{ $t('newRequest.kotiovkaSorusuPqt') }}</span>
        <span v-else-if="requestType==='AUC'">{{ $t('newRequest.hrrac') }}</span>
        <span v-else-if="requestType==='REV'">{{ $t('newRequest.ksHrrac') }}</span>
        <span v-else>{{ requestType }}</span>
      </h3>

      <div class="row">
        <div
          v-if="requestType==='PQ'"
          class="col-xl-8 "
        >
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-8">
                  <h3>{{ $t('newRFQRequest.rfqKotirovka') }}</h3>
                  <p>
                    {{ $t('newRFQRequest.sorunuDahaDetallYaratmaqOlur') }} <br>
                    {{ $t('newRFQRequest.soruyaGlnTkliflrYalnzMddtBitndBilinir') }} <br>
                    {{ $t('newRFQRequest.tlbinizUyunTklifSistemTrfindnAvtomatikSeilir') }}
                  </p>
                </div>
                <div class="col-md-4 d-flex align-items-center justify-content-center">
                  <button
                    class="btn btn-primary"
                    @click.prevent="
                      $router.push({name: 'newRequest', query: {type: 'PQT'}})"
                  >
                    {{ $t('newRequest.se') }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-8">
                  <h3>{{ $t('newRFQRequest.rfq') }}</h3>
                  <p>
                    {{ $t('newRFQRequest.soruyaGlnTkliflriSonTarixBitmdnDGrmkOlur') }} <br>
                    {{ $t('newRFQRequest.tlbinizUyunTklifZnzSeirsizSistemSemir') }}
                  </p>
                </div>
                <div class="col-md-4 d-flex align-items-center justify-content-center">
                  <button
                    class="btn btn-primary"
                    @click.prevent="
                      $router.push({name: 'newRequest', query: {type: 'RFQ'}})"
                  >
                    {{ $t('newRequest.se') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="col-xl-8 "
        >
          <input
            id="fileInput"
            ref="file"
            type="file"
            style="display: none"
            @change="setPhoto"
          >

          <input
            id="excelInput"
            ref="excelFile"
            type="file"
            style="display: none"
            @change="setExcel"
          >
          <form @submit.prevent="createRequest">
            <div class="card">
              <div class="card-body">
                <div
                  v-if="['PQT','RFQ'].indexOf(requestType)>-1"
                  class="mb-3 text-center"
                >
                  <div class="btn-group btn-group-lg d-flex ">
                    <button
                      class="btn btn-lg flex-1"
                      :class="{
                        'btn-outline-primary': requestType!=='RFQ',
                        'btn-primary': requestType==='RFQ',
                      }"
                      @click.prevent="requestType='RFQ'"
                    >
                      {{ $t('newRFQRequest.rfq') }}
                    </button>


                    <button
                      class="btn btn-lg flex-1"
                      :class="{
                        'btn-outline-primary': requestType!=='PQT',
                        'btn-primary': requestType==='PQT',
                      }"
                      @click.prevent="requestType='PQT'"
                    >
                      {{ $t('newRFQRequest.rfqKotirovka') }}
                    </button>
                  </div>
                </div>

                <div
                  v-if="['RFI','RFQ', 'PQT', 'REV','AUC','POL'].indexOf(requestType)>-1
                    || (requestType ==='OFR' && profile !== 'LOGISTIC' ) "
                  class="mb-3"
                >
                  <div
                    class="card"
                    style="background: #dddddd"
                  >
                    <div class="card-body">
                      <label
                        for="new_request_sector"
                        class="lead font-weight-bold"
                      >
                        <span v-if="requestType==='AUC'">{{ $t('newAUCRequest.hrracnzHansSahyAiddir') }}</span>
                        <span v-if="requestType==='REV'">{{ $t('newRevRequest.ksHrracnzHansSahyAiddir') }}</span>
                        <span v-else>{{ $t('newInfoRequest.sorunuzHansSahyAiddir') }}</span>
                      </label>

                      <SelectedSectorView
                        :sectors="requestSectors"
                        :parent-id="0"
                      />

                      <div class="mt-3">
                        <button
                          v-b-modal.modal-sector-selection
                          type="button"
                          class="btn btn-sm btn-primary"
                        >
                          {{ $t('companyProfile.faliyytSahsiniSein') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="requestType === 'RFI'"
                  class="mb-4"
                >
                  <div class="form-check">
                    <input
                      id="requestSubTypeInfo"
                      v-model="requestSubType"
                      class="form-check-input"
                      type="radio"
                      name="requestSubType"
                      value="info"
                    >
                    <label
                      class="form-check-label"
                      for="requestSubTypeInfo"
                    >
                      <strong>{{ $t('newRequest.mlumatAlram') }}</strong>
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      id="requestSubTypePurchase"
                      v-model="requestSubType"
                      class="form-check-input"
                      type="radio"
                      name="requestSubType"
                      value="purchase"
                    >
                    <label
                      class="form-check-label"
                      for="requestSubTypePurchase"
                    >
                      <strong>{{ $t('newRequest.satnAlram') }}</strong>
                    </label>
                  </div>
                </div>

                <div
                  v-if="requestType === 'OFR' && profile !=='LOGISTIC'"
                  class="mb-4"
                >
                  <div class="form-check">
                    <input
                      id="requestSubTypeWholesale"
                      v-model="requestSubType"
                      class="form-check-input"
                      type="radio"
                      name="requestSubType"
                      value="wholesale"
                    >
                    <label
                      class="form-check-label"
                      for="requestSubTypeWholesale"
                    >
                      <strong>{{ $t('newOfferRequest.topdanSat') }}</strong>
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      id="requestSubTypeRetail"
                      v-model="requestSubType"
                      class="form-check-input"
                      type="radio"
                      name="requestSubType"
                      value="retail"
                    >
                    <label
                      class="form-check-label"
                      for="requestSubTypeRetail"
                    >
                      <strong>{{ $t('newOfferRequest.prakndSat') }}</strong>
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      id="requestSubTypeService"
                      v-model="requestSubType"
                      class="form-check-input"
                      type="radio"
                      name="requestSubType"
                      value="service"
                    >
                    <label
                      class="form-check-label"
                      for="requestSubTypeService"
                    >
                      <strong>{{ $t('newAUCRequest.xidmt') }}</strong>
                    </label>
                  </div>
                </div>


                <div
                  v-if="requestType === 'REV'"
                  class="card text-danger"
                >
                  <div class="card-body">
                    {{ $t('newRevRequest.ksHrracnYalnzBirQalibiOlaBilr') }} <br>
                    {{ $t('newRevRequest.qalibIrktinTklifiniSasszYerImtinaEdrsizsQarTrfSizi') }}
                    <br>
                    {{ $t('newAUCRequest.saslandrmanzYalnzMzakirlrdEtdiyinizDanaGrMyynOluna') }} <br>
                    {{ $t('newRevRequest.btnDetallarMzakirBlmsindAparmanzTvsiyyOlunur') }}
                  </div>
                </div>

                <div
                  v-if="requestType === 'AUC'"
                  class="card text-danger"
                >
                  <div class="card-body">
                    {{ $t('newAUCRequest.hrracnYalnzBirQalibiOlaBilr') }} <br>
                    {{ $t('newAUCRequest.qalibIrktinTklifiniSasszYerImtinaEdrsizsQarTrfSizi') }}
                    <br>
                    {{ $t('newAUCRequest.saslandrmanzYalnzMzakirlrdEtdiyinizDanaGrMyynOluna') }} <br>
                    {{ $t('newAUCRequest.btnDetallarMzakirBlmsindAparmanzTlbOlunur') }}
                  </div>
                </div>

                <div class="mb-3">
                  <label v-if="requestType==='AUC'"> {{ $t('newAUCRequest.hrracnAd') }}</label>
                  <label v-else-if="requestType==='REV'"> {{ $t('newRequest.ksHrracnAd') }}</label>
                  <label v-else-if="['POL'].indexOf(requestType)>-1"> {{ $t('newPolRequest.ssvermMvzusununBal') }}</label>
                  <label v-else>{{ $t('newInfoRequest.soruBal') }}</label>
                  <b-form-input
                    id="new_request_title"
                    v-model="requestTitle"
                    size="lg"
                    type="text"
                    required
                  />
                </div>

                <div v-if="requestType === 'POL'">
                  <div class="mb-3">
                    <label>{{ $t('newPolRequest.birNeCavabSeilBilrmi') }}</label>
                    <select
                      v-model="orderExtras.multiSelect"
                      class="form-control form-control-lg"
                      required
                    >
                      <option :value="0">
                        {{ $t('newPolRequest.xeyr') }}
                      </option>
                      <option :value="1">
                        {{ $t('newPolRequest.bli') }}
                      </option>
                    </select>
                  </div>

                  <div class="mb-3">
                    <label>{{ $t('newPolRequest.istifadiZCavabVariantnLavEdBilrmi') }}</label>
                    <select
                      v-model="orderExtras.ownVariant"
                      class="form-control form-control-lg"
                      required
                    >
                      <option :value="0">
                        {{ $t('newPolRequest.xeyr') }}
                      </option>
                      <option :value="1">
                        {{ $t('newPolRequest.bli') }}
                      </option>
                    </select>
                  </div>
                </div>
                <div v-if="requestType === 'PQT'">
                  <div class="card bg-light border border-secondary text-dark ">
                    <div class="card-body">
                      <h3>{{ $t('newRFQRequest.ilkinZruriTlblr') }}</h3>
                      <div class="mb-3">
                        <label>{{ $t('newRFQRequest.valyuta') }}</label>
                        <div class="input-group">
                          <select
                            v-model="orderExtras.currency"
                            class="form-control"
                            min="1"
                            required
                          >
                            <option value="AZN">
                              {{ $t('newAUCRequest.azn') }}
                            </option>
                            <option value="USD">
                              {{ $t('newRFQRequest.usd') }}
                            </option>
                            <option value="EUR">
                              {{ $t('newRFQRequest.eur') }}
                            </option>
                          </select>
                          <div class="input-group-text">
                            -
                          </div>
                          <select
                            v-model="orderExtras.currencyRequired"
                            class="form-control"
                            min="1"
                            required
                          >
                            <option value="yes">
                              {{ $t('pqtExtrasView.mtlq') }}
                            </option>
                            <option value="no">
                              {{ $t('pqtExtrasView.arzuOlunan') }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label>{{ $t('newRFQRequest.incotermsRtlri2020') }}</label>
                        <div class="input-group">
                          <select
                            v-model="orderExtras.incoterms"
                            class="form-control"
                            min="1"
                            required
                          >
                            <option value="NONE">
                              {{ $t('offerExtrasView.yoxdur') }}
                            </option>
                            <option
                              v-for=" i in inctermsList"
                              :key="i"
                              :value="i"
                            >
                              {{ i }}
                            </option>
                          </select>
                          <div class="input-group-text">
                            -
                          </div>
                          <select
                            v-if="orderExtras.incoterms && orderExtras.incoterms !=='NONE'"
                            v-model="orderExtras.incotermsRequired"
                            class="form-control"
                            min="1"
                            required
                          >
                            <option value="yes">
                              {{ $t('pqtExtrasView.mtlq') }}
                            </option>
                            <option value="no">
                              {{ $t('pqtExtrasView.arzuOlunan') }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="mb-3">
                        <label>{{ $t('newRFQRequest.dniSulu') }}</label>
                        <div class="input-group">
                          <select
                            v-model="orderExtras.payment"
                            class="form-control"
                            min="1"
                            required
                          >
                            <option value="transfer">
                              {{ $t('offerExtrasView.krm') }}
                            </option>
                            <option value="cash">
                              {{ $t('offerExtrasView.nad') }}
                            </option>
                            <option value="both">
                              {{ $t('offerExtrasView.hrIkisi') }}
                            </option>
                          </select>
                          <div class="input-group-text">
                            -
                          </div>
                          <select
                            v-model="orderExtras.paymentRequired"
                            class="form-control"
                            min="1"
                            required
                          >
                            <option value="yes">
                              {{ $t('pqtExtrasView.mtlq') }}
                            </option>
                            <option value="no">
                              {{ $t('pqtExtrasView.arzuOlunan') }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="mb-3">
                        <label>{{ $t('newRFQRequest.atdrlma') }}</label>
                        <div class="input-group">
                          <select
                            v-model="orderExtras.deliveryNeeded"
                            class="form-control"
                            min="1"
                            required
                          >
                            <option value="yes">
                              {{ $t('newRFQRequest.lazmdr') }}
                            </option>
                            <option value="no">
                              {{ $t('newRFQRequest.lazmDeyil') }}
                            </option>
                          </select>
                          <input
                            v-if="orderExtras.deliveryNeeded && orderExtras.deliveryNeeded==='yes' "
                            v-model.number="orderExtras.delivery"
                            type="number"
                            class="form-control"
                            min="1"
                            required
                          >
                          <div
                            v-if="orderExtras.deliveryNeeded && orderExtras.deliveryNeeded==='yes' "
                            class="input-group-text"
                          >
                            {{ $t('newRFQRequest.gnRzind') }}
                          </div>
                        </div>
                      </div>

                      <div class="mb-3">
                        <label>{{ $t('newRFQRequest.ilkinZruriTlblrlBalQeydlr') }}</label>

                        <div>
                          <textarea
                            v-model.trim="orderExtras.initialRequirementNotes"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="requestType === 'AUC'">
                  <div class="mb-3">
                    <label>{{ $t('newAUCRequest.balancQiymt') }}</label>
                    <div class="input-group">
                      <b-form-input
                        v-model="orderExtras.startingPrice"
                        type="number"
                        min="1"
                        required
                      />
                      <div class="input-group-text">
                        {{ $t('newAUCRequest.azn') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="requestType === 'LOG'">
                  <div class="">
                    <div class="row">
                      <div class="col-sm-6 mb-3">
                        <div class=" px-3 ribbon-wrapper">
                          <div class="ribbon ribbon-primary ribbon-space-bottom">
                            {{ $t('newRequest.yklnmYeri') }}
                          </div>
                          <div class="mb-3">
                            <label>{{ $t('newLogisticRequest.lk') }}</label>
                            <b-form-input
                              v-model="orderExtras.pickUpCountry"
                              type="text"
                              required
                            />
                          </div>
                          <div class="mb-3">
                            <label>{{ $t('newLogisticRequest.hr') }}</label>
                            <b-form-input
                              v-model="orderExtras.pickUpCity"
                              type="text"
                              required
                            />
                          </div>
                          <div class="mb-3">
                            <label>{{ $t('nvanIstiqamt') }}</label>
                            <b-form-input
                              v-model="orderExtras.pickUpAddress"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 mb-3">
                        <div class=" px-3 ribbon-wrapper">
                          <div class="ribbon ribbon-warning ribbon-space-bottom">
                            {{ $t('newRequest.boaldlmaYeri') }}
                          </div>
                          <div class=" mb-3">
                            <label>{{ $t('newLogisticRequest.lk') }}</label>
                            <b-form-input
                              v-model="orderExtras.dropOffCountry"
                              type="text"
                              required
                            />
                          </div>
                          <div class=" mb-3">
                            <label>{{ $t('newLogisticRequest.hr') }}</label>
                            <b-form-input
                              v-model="orderExtras.dropOffCity"
                              type="text"
                              required
                            />
                          </div>
                          <div class=" mb-3">
                            <label>{{ $t('nvanIstiqamt') }}</label>
                            <b-form-input
                              v-model="orderExtras.dropOffAddress"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.sorununDvriliyiVDigrQeydlr') }}</label>
                    <b-form-textarea
                      v-model="orderExtras.notes"
                      size="lg"
                      required
                      rows="4"
                    />
                  </div>


                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.satcIlRazladnzIncotermsRti') }}</label>
                    <select
                      v-model="orderExtras.incoterms"
                      class="form-control form-control-lg"
                      required
                    >
                      <option
                        v-for=" i in inctermsList"
                        :key="i"
                        :value="i"
                      >
                        {{ i }}
                      </option>
                    </select>
                  </div>

                  <div class="mb-3">
                    <label>{{ $t('newLogisticRequest.hansNvDanmalarNTklifAlmaqIstyirsiniz') }}</label>

                    <multiselect
                      v-model="orderExtras.types"
                      :placeholder="$t('newLogisticRequest.danmaNvnSein')"
                      :label="$t('newLogisticRequest.value')"
                      track-by="key"
                      :options="typeList"
                      :multiple="true"
                    />
                    <div class="text-warning ml-3">
                      {{ $t('newLogisticRequest.birNeDanmaNvSeBilrsiniz') }}
                    </div>
                  </div>

                  <p class="lead mb-3 text-danger">
                    {{ $t('newLogisticRequest.nvbtiMrhldSizDanacaqYklrlBalMlumatDolduracaqsnz') }}
                  </p>
                </div>
                <div v-else-if="requestType === 'TRS'">
                  <div class="">
                    <div class="row">
                      <div class="col-sm-6 mb-3">
                        <div class=" px-3 ribbon-wrapper">
                          <div class="ribbon ribbon-primary ribbon-space-bottom">
                            {{ $t('newRequest.ykHardanGtrlmlidir') }}
                          </div>
                          <div class="mb-3">
                            <label>{{ $t('newLogisticRequest.lk') }}</label>
                            <b-form-input
                              v-model="orderExtras.pickUpCountry"
                              type="text"
                              required
                            />
                          </div>
                          <div class="mb-3">
                            <label>{{ $t('newLogisticRequest.hr') }}</label>
                            <b-form-input
                              v-model="orderExtras.pickUpCity"
                              type="text"
                              required
                            />
                          </div>
                          <div class="mb-3">
                            <label>{{ $t('nvanIstiqamt') }}</label>
                            <b-form-input
                              v-model="orderExtras.pickUpAddress"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 mb-3">
                        <div class=" px-3 ribbon-wrapper">
                          <div class="ribbon ribbon-warning ribbon-space-bottom">
                            {{ $t('newRequest.haraAtdrlmaldr') }}
                          </div>
                          <div class=" mb-3">
                            <label>{{ $t('newLogisticRequest.lk') }}</label>
                            <b-form-input
                              v-model="orderExtras.dropOffCountry"
                              type="text"
                              required
                            />
                          </div>
                          <div class=" mb-3">
                            <label>{{ $t('newLogisticRequest.hr') }}</label>
                            <b-form-input
                              v-model="orderExtras.dropOffCity"
                              type="text"
                              required
                            />
                          </div>
                          <div class=" mb-3">
                            <label>{{ $t('nvanIstiqamt') }}</label>
                            <b-form-input
                              v-model="orderExtras.dropOffAddress"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label>{{ $t('newTRSRequest.yknXacaTarix') }}</label>
                    <DatePicker
                      v-model="orderExtras.deadline"
                      mode="date"
                      :min-date="minDeadline"
                      :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                      :is-required="true"
                      :model-config="{type: 'string', mask: 'YYYY-MM-DD'}"
                    >
                      <template #default="{ inputValue, inputEvents }">
                        <input
                          type="text"
                          class="form-control "
                          :value="inputValue"
                          placeholder=""
                          required
                          v-on="inputEvents"
                        >
                      </template>
                    </DatePicker>
                  </div>

                  <p class="lead mb-3 text-danger">
                    {{ $t('newLogisticRequest.nvbtiMrhldSizDanacaqYklrlBalMlumatDolduracaqsnz') }}
                  </p>
                </div>

                <div v-else-if="requestType === 'TRK'">
                  <div class="">
                    <div class="row">
                      <div class="col-sm-6 mb-3">
                        <div class=" px-3 ribbon-wrapper  border rounded ">
                          <div class="ribbon ribbon-primary ribbon-space-bottom">
                            {{ $t('newRequest.balanc') }}
                          </div>
                          <div class="mb-3">
                            <label>{{ $t('newLogisticRequest.lk') }}</label>
                            <b-form-input
                              v-model="orderExtras.pickUpCountry"
                              type="text"
                              required
                            />
                          </div>
                          <div class="mb-3">
                            <label>{{ $t('newLogisticRequest.hr') }}</label>
                            <b-form-input
                              v-model="orderExtras.pickUpCity"
                              type="text"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 mb-3">
                        <div class=" px-3 ribbon-wrapper  border rounded ">
                          <div class="ribbon ribbon-warning ribbon-space-bottom">
                            {{ $t('newRequest.boaldlmaYeri') }}
                          </div>
                          <div class=" mb-3">
                            <label>{{ $t('newLogisticRequest.lk') }}</label>
                            <b-form-input
                              v-model="orderExtras.dropOffCountry"
                              type="text"
                              required
                            />
                          </div>
                          <div class=" mb-3">
                            <label>{{ $t('newLogisticRequest.hr') }}</label>
                            <b-form-input
                              v-model="orderExtras.dropOffCity"
                              type="text"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.yolaDmTarixi') }}</label>
                    <DatePicker
                      v-model="orderExtras.deadline"
                      mode="date"
                      :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                      :min-date="minDeadline"
                      :is-required="true"
                      :model-config="{type: 'string', mask: 'YYYY-MM-DD'}"
                    >
                      <template #default="{ inputValue, inputEvents }">
                        <input
                          type="text"
                          class="form-control "
                          :value="inputValue"
                          placeholder=""
                          required
                          v-on="inputEvents"
                        >
                      </template>
                    </DatePicker>
                  </div>
                  <div class=" px-3 ribbon-wrapper border rounded mb-3">
                    <div class="ribbon ribbon-success ribbon-space-bottom">
                      {{ $t('newRequest.qbulEdilckYkHcmi') }}
                    </div>
                    <div class="row">
                      <div class="col-sm-6 mb-3">
                        <label>{{ $t('newRequest.miqdar') }}</label>
                        <b-form-input
                          v-model.number="orderExtras.loadSize"
                          type="number"
                          required
                        />
                      </div>
                      <div class="col-sm-6 mb-3">
                        <label>{{ $t('newOfferRequest.lVahidi') }}</label>
                        <select
                          v-model="orderExtras.loadUnit"
                          class="form-control"
                          required
                        >
                          <option
                            v-for="v in loadUnits"
                            :key="v"
                            :value="v"
                          >
                            {{ v }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label>{{ $t('newTRKRequest.hansNvYklrQbulEdilir') }}</label>

                    <multiselect
                      v-model="orderExtras.types"
                      :placeholder="$t('newTRKRequest.ykNvnSein')"
                      :label="$t('newLogisticRequest.value')"
                      track-by="key"
                      :options="advTypeList"
                      :multiple="true"
                    />
                  </div>
                </div>

                <div
                  v-if="requestType === 'RFQ' || requestType === 'PQT'"
                  class="card text-danger"
                >
                  <div class="card-body">
                    {{ $t('newRFQRequest.tdarknnDzgnQiymtVermsiNTlbinizBardMlumatTfsilatlQe') }}
                  </div>
                </div>
                <div
                  v-if="['LOG','TRS','TRS','TRK'].indexOf(requestType)===-1"
                  class="mb-3"
                >
                  <label v-if="requestType==='AUC'">{{ $t('newAUCRequest.hrracBardMlumatlar') }}</label>
                  <label v-else-if="requestType==='REV'">{{ $t('newRevRequest.ksHrracBardMlumatlar') }}</label>
                  <label v-else-if="requestType==='POL'">{{ $t('newPolRequest.ssvermMvzusununMtni') }}</label>
                  <label v-else>{{ $t('newInfoRequest.soruMtni') }}</label>
                  <b-form-textarea
                    id="new_request_description"
                    v-model="requestDescription"
                    size="lg"
                    required
                    rows="4"
                  />
                  <span
                    v-if="requestDescription.length<20"
                    class="text-danger"
                  >{{ $t('newAUCRequest.soruSpesifikasiyasNAz20SimvoldanIbartOlmaldr') }}</span>
                </div>


                <div
                  v-if="requestType !== 'OFR'"
                  class="mb-3"
                >
                  <label v-if="requestType==='POL'">{{ $t('newRequest.ssvermNSonTarix') }}</label>
                  <label v-else-if="requestType==='REV'">
                    {{ $t('newRevRequest.ksHrracNSonTarix') }}
                  </label>
                  <label v-else-if="requestType==='AUC'">
                    {{ $t('newAUCRequest.hrracNSonTarix') }}
                  </label>
                  <label v-else-if="['LOG','RFQ'].indexOf(requestType)>-1">
                    {{ $t('newRFQRequest.tklifNSonTarix') }}
                  </label>
                  <label v-else>{{ $t('newInfoRequest.sorununBitmTarixi') }}</label>
                  <DatePicker
                    v-model="requestDeadline"
                    mode="dateTime"
                    is24hr
                    :minute-increment="15"
                    :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                    :min-date="minDeadline"
                    :is-required="true"
                    :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
                  >
                    <template #default="{ inputValue, inputEvents }">
                      <input
                        type="text"
                        class="form-control "
                        :value="inputValue"
                        placeholder=""
                        required
                        v-on="inputEvents"
                      >
                    </template>
                  </DatePicker>
                </div>
                <div
                  v-if="requestType === 'PQT' "
                  class="mb-3"
                >
                  <label>{{ $t('newRFQRequest.qalibinElanOlunmaTarixi') }}</label>

                  <DatePicker
                    v-model="orderExtras.winnerDeadline"
                    mode="dateTime"
                    is24hr
                    :minute-increment="15"
                    :min-date="requestDeadline"
                    :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                    :is-required="true"
                    :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
                  >
                    <template #default="{ inputValue, inputEvents }">
                      <input
                        type="text"
                        class="form-control "
                        :value="inputValue"
                        placeholder=""
                        required
                        v-on="inputEvents"
                      >
                    </template>
                  </DatePicker>
                </div>


                <div v-if="requestType === 'OFR'">
                  <div v-if="requestSubType==='wholesale'">
                    <div class="mb-3">
                      <div class="row">
                        <div class="col-sm-6 mb-3">
                          <label> {{ $t('newOfferRequest.minimumSifariMiqdar') }}</label>
                          <b-form-input
                            v-model.number="orderExtras.minOrder"
                            type="number"
                            required
                          />
                        </div>
                        <div class="col-sm-6 mb-3">
                          <label>{{ $t('newOfferRequest.lVahidi') }}</label>
                          <select
                            v-model="orderExtras.unit"
                            class="form-control"
                            required
                          >
                            <option
                              v-for="v in loadUnits"
                              :key="v"
                              :value="v"
                            >
                              {{ v }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class=" mb-3">
                        <label> {{ $t('newOfferRequest.topdanSatQiymti1N', {unit: orderExtras.unit}) }}</label>
                        <div class="input-group">
                          <b-form-input
                            v-model.number="orderExtras.price"
                            type="number"
                            required
                          />
                          <div class="input-group-text">
                            <strong>{{ $t('newAUCRequest.azn') }}</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-6 mb-3">
                      <label> {{ $t('newOfferRequest.dniSulu') }}</label>
                      <select
                        v-model="orderExtras.payment"
                        class="form-control"
                        required
                      >
                        <option value="transfer">
                          {{ $t('offerExtrasView.krm') }}
                        </option>
                        <option value="cash">
                          {{ $t('offerExtrasView.nad') }}
                        </option>
                        <option value="both">
                          {{ $t('offerExtrasView.hrIkisi') }}
                        </option>
                      </select>
                    </div>
                    <div
                      v-if="requestSubType!=='service' && requestSubType!==''"
                      class="col-sm-6 mb-3"
                    >
                      <label> {{ $t('newOfferRequest.atdrlma') }}</label>
                      <select
                        v-model="orderExtras.delivery"
                        class="form-control"
                        required
                      >
                        <option value="no">
                          {{ $t('offerExtrasView.yoxdur') }}
                        </option>
                        <option value="yes">
                          {{ $t('offerExtrasView.qiymtDaxildir') }}
                        </option>
                        <option value="paid">
                          {{ $t('offerExtrasView.qiymtDaxilDeyil') }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>


                <div
                  v-if="['LOG','RFQ','TRS','TRK','REV','AUC'].indexOf(requestType)===-1"
                  class="mb-3"
                >
                  <label>{{ $t('newInfoRequest.lavFayllar') }}</label> <br>


                  <div class="row">
                    <div
                      class="col-md-3 mb-3"
                      style="cursor: pointer"
                      @click.prevent="selectPhoto(-1)"
                    >
                      <div class="card bg-primary">
                        <div class="card-body d-flex text-white w-100 justify-content-center align-items-center ">
                          {{ $t('newAUCRequest.ykl') }}
                        </div>
                      </div>
                    </div>

                    <div
                      v-for="(f,i) in requestFiles"
                      :key="f.path"
                      class="col-md-3 mb-3"
                    >
                      <div class="position-relative">
                        <a
                          v-if="isPhoto(f.path)"
                          target="_blank"
                          :href="getPhoto(f.path,'')"
                        >
                          <img
                            :src="getPhoto(f.path,'thumbnailCropped')"
                            class="img-thumbnail"
                            style="max-height: 200px;"
                            :alt="$t('newRequest.requestPhoto')"
                          >
                        </a>
                        <a
                          v-else
                          target="_blank"
                          :href="getPhoto(f.path,'')"
                          class="card h-100 border border-dark "
                          style="height: 100%"
                        >
                          <div class="card-body d-flex text-dark w-100 justify-content-center align-items-center ">
                            {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.path.split('.').pop() }}
                          </div>
                        </a>

                        <div
                          style="position: absolute; top:0 ; right:0; padding: 10px; background: rgba(0,0,0,0.7);"
                        >
                          <div @click="deleteFile(i)">
                            <feather
                              style="color: white;"
                              type="trash"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-2 ">
                    <div
                      v-if="uploadProgress >0 && uploadProgress <100"
                      class="progress"
                    >
                      <div
                        class="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        aria-valuenow="75"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        :style="{width: `${uploadProgress}%`}"
                      />
                    </div>
                  </div>
                </div>


                <div
                  v-if="['OFR'].indexOf(requestType)===-1"
                  class=" mb-2 "
                >
                  <div class="col-md-12 d-flex align-items-center">
                    <div class="checkbox checkbox-success mt-3">
                      <b-form-checkbox
                        v-model="requestIsPrivate"
                        value="1"
                        :disabled="onlyVendors>0"
                      >
                        <div>
                          {{ $t('newAUCRequest.mllifiGizlt') }} <br> <span
                            v-if="requestIsPrivate"
                            class="text-danger"
                          >
                            {{ $t('newAUCRequest.mllifiDigrIstifadilrYalnzMzakiryBalayarsaGrcklr') }}
                          </span>
                          <span
                            v-else
                            class="text-success"
                          >
                            {{ $t('newAUCRequest.mllifiBtnIstifadilrGrcklr') }}
                          </span>
                        </div>
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>

                <div
                  v-if="requestType !== 'OFR'"
                  class=" mb-2 "
                >
                  <div class="col-md-12 d-flex align-items-center">
                    <div class="checkbox checkbox-success mt-3">
                      <b-form-checkbox
                        v-model="requestIsPersonalAllowed"
                        value="1"
                      >
                        {{ $t('newAUCRequest.frdiVensizXslrSorunuCavablayaBilsin') }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>

                <div class=" mb-2 ">
                  <div class="col-md-12 d-flex align-items-center">
                    <div class="checkbox checkbox-success mt-3">
                      <b-form-checkbox
                        v-model="onlyVerified"
                        value="1"
                      >
                        {{ $t('newAUCRequest.ancaqTsdiqlnmiIrktIstifadilriCavablayaBilsin') }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>

                <div
                  v-if="['RFQ','PQT','REV','LOG','LGI','TRS','CSI','WHI'].indexOf(requestType)>-1 && profile==='PROCUREMENT'"
                  class=" mb-2 "
                >
                  <div class="col-md-12 d-flex align-items-center">
                    <div class="checkbox checkbox-success mt-3">
                      <b-form-checkbox
                        v-model="onlyVendors"
                        value="1"
                        :disabled="!vendorManagementAvailable || requestIsPrivate>0 "
                      >
                        {{ $t('newInfoRequest.ancaqTsdiqlnmiTdarklrimCavablayaBilsin') }}
                        <br>
                        <span
                          v-if="!vendorManagementAvailable"
                          class="text-danger"
                        >
                          {{ $t('newInfoRequest.buFunksiyanIstifadEtmkN') }} <strong>{{ $t('newInfoRequest.vendorManagement') }}</strong> {{ $t('newInfoRequest.lavsiniAktivldirmlisniz') }}

                          <router-link :to="{name: 'addOnPage'}">{{ $t('newInfoRequest.aktivldir') }}</router-link>
                        </span>
                        <span
                          v-if="requestIsPrivate>0"
                          class="text-danger"
                        >
                          {{ $t('newInfoRequest.gizliSorularNBuFunskiyaAktivDeyil') }}
                        </span>
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="['RFQ','PQT', 'REV','AUC'].indexOf(requestType)>-1"
              class="card"
            >
              <div class="card-header">
                <h3 class="mb-0">
                  {{ $t('newAUCRequest.mhsullar') }}
                </h3>
              </div>
              <div class="card-body">
                <div
                  v-for="(p,index) in products"
                  :key="index"
                  class="card bg-light text-dark"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label>{{ $t('newAUCRequest.tip') }}</label>
                          <select
                            v-model="p.productType"
                            class="form-control"
                            required
                          >
                            <option value="PRODUCT">
                              {{ $t('newAUCRequest.mhsul') }}
                            </option>
                            <option value="SERVICE">
                              {{ $t('newAUCRequest.xidmt') }}
                            </option>
                          </select>
                        </div>

                        <div class="mb-3">
                          <label>{{ $t('newAUCRequest.mhsulunXidmtinAd') }}</label>
                          <input
                            v-model="p.name"
                            class="form-control"
                            type="text"
                            required
                          >
                        </div>

                        <div class="mb-3">
                          <label>{{ $t('newAUCRequest.mhsulXidmtHaqqndaQeydlr') }}</label>
                          <textarea
                            v-model="p.note"
                            class="form-control"
                            type="text"
                          />
                        </div>


                        <div class="mb-3">
                          <div class="row">
                            <div class="col-6">
                              <label>{{ $t('newAUCRequest.miqdar') }}</label>
                              <input
                                v-model="p.count"
                                class="form-control"
                                type="number"
                                step="0.01"
                                required
                              >
                            </div>
                            <div class="col-6">
                              <label>{{ $t('newAUCRequest.lVahidi') }}</label>
                              <select
                                v-if="p.productType==='SERVICE'"
                                v-model="p.unit"
                                class="form-control"
                                required
                              >
                                <option
                                  v-for="v in serviceUnits"
                                  :key="v"
                                  :value="v"
                                >
                                  {{ v }}
                                </option>
                              </select>
                              <select
                                v-else
                                v-model="p.unit"
                                class="form-control"
                                required
                              >
                                <option
                                  v-for="v in productUnits"
                                  :key="v"
                                  :value="v"
                                >
                                  {{ v }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <label>{{ $t('newAUCRequest.lavFayl') }}</label> <br>

                        <img
                          v-if="p.photo"
                          :src="getPhoto(p.photo,'mediumCropped')"
                          alt=""
                          class="img-thumbnail"
                          style="max-height: 300px; max-width: 100%;"
                        >
                        <div class="mt-2 ">
                          <button
                            type="button"
                            class="btn btn-sm m-2 btn-outline-primary"
                            @click.prevent="selectPhoto(index)"
                          >
                            {{ $t('newAUCRequest.ykl') }}
                          </button>
                          <button
                            v-if="p.photo"
                            type="button"
                            class="btn btn-sm  m-2 btn-outline-danger"
                            @click.prevent="p.photo=''"
                          >
                            {{ $t('newRequest.sil') }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="index>0"
                      class="text-left"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="deleteProduct(index)"
                      >
                        {{ $t('newRequest.mhsuluxidmtiSil') }}
                      </button>
                    </div>
                  </div>
                </div>


                <div v-if="['RFQ','PQT'].indexOf(requestType)>-1 || products.length<1">
                  <button
                    type="button"
                    class="btn btn-lg btn-primary"
                    @click="addNewProduct()"
                  >
                    {{ $t('newRequest.nvbtiMhsulxidmt') }}
                  </button>
                </div>
              </div>
            </div>
            <div
              v-if="['POL'].indexOf(requestType)>-1"
              class="card"
            >
              <div class="card-header">
                <h3 class="mb-0">
                  {{ $t('newPolRequest.cavabVariantlar') }}
                </h3>
              </div>


              <ul class="list-group list-group-flush">
                <li
                  v-for="(p,index) in pollAnswerList"
                  :key="index"
                  class="list-group-item"
                >
                  <div class="input-group">
                    <input
                      v-model="pollAnswerList[index]"
                      class="form-control"
                      type="text"
                      required
                    >

                    <button
                      type="button"
                      class="btn btn-sm btn-danger"
                      @click="deleteVariant(index)"
                    >
                      {{ $t('newPolRequest.variantSil') }}
                    </button>
                  </div>
                </li>
              </ul>

              <div class="card-footer">
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click="pollAnswerList.push('')"
                >
                  {{ $t('newPolRequest.yeniCavabVariant') }}
                </button>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div v-if="requestType==='PQT'">
                  <div class="checkbox checkbox-success mb-3">
                    <b-form-checkbox
                      v-model="rfqTerms"
                      value="1"
                      required
                    >
                      <router-link
                        target="_blank"
                        :to="{path: '/dashboard/page/pqt_terms'}"
                      >
                        {{ $t('newRFQRequest.rfqKotirovkaQaydalarnQbulEdirm') }}
                      </router-link>
                    </b-form-checkbox>
                  </div>
                </div>

                <div v-else-if="requestType==='RFQ'">
                  <div class="checkbox checkbox-success mb-3">
                    <b-form-checkbox
                      v-model="rfqTerms"
                      value="1"
                      required
                    >
                      <router-link
                        target="_blank"
                        :to="{path: '/dashboard/page/rfq_terms'}"
                      >
                        {{ $t('newRFQRequest.rfqQiymtSorusuQaydalarnQbulEdirm') }}
                      </router-link>
                    </b-form-checkbox>
                  </div>
                </div>


                <button class="btn btn-lg btn-success">
                  <span v-if="['LOG','TRS'].indexOf(requestType)>-1">{{ $t('newTRSRequest.nvbtiMrhl') }}</span>
                  <span v-else-if="['AUC'].indexOf(requestType)>-1">{{ $t('newAUCRequest.hrracYarat') }}</span>
                  <span v-else-if="['REV'].indexOf(requestType)>-1">{{ $t('newRevRequest.ksHrracYarat') }}</span>
                  <span v-else>{{ $t('newInfoRequest.sorunuYarat') }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="col-xl-4 ">
          <div
            v-if="requestType === 'RFQ'"
            class="card"
          >
            <div class="card-body bg-info text-center">
              <i class="fa fa-5x fa-file-excel-o" />

              <br>
              <p class="lead mt-3">
                {{ $t('newRFQRequest.artqRfqSorularnExcelFaylVasitsilYaradaBilrsiniz') }}
              </p>

              <p>
                <a
                  :href="`${mediaBase}/template/SCC_RFQ_TEMPLATE.xlsx`"
                  target="_blank"
                  class="btn btn-light"
                >
                  {{ $t('newRFQRequest.ablonFaylYkl') }}
                </a>
              </p>
              <p>
                <button
                  type="button"
                  class="btn btn-light"
                  @click.prevent="selectExcel()"
                >
                  {{ $t('newRFQRequest.hazrFaylGeriYkl') }}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->

    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="false"
      class="theme-modal"
      :busy="false"
      :hide-footer="true"
    >
      <sector_selection_modal
        :max-selection="5"
        :parent-sector="null"
        :selected="requestSectors"
        @done="sectorSelected($event)"
      />
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  createRequest, createRequestFromExcel, getVendorManagementStatus,
  getWorkingSectors, upload
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Datepicker from 'vuejs-datepicker';
import {deliveryTypes, getPhoto, loadTypes} from "@/repositories/Utils";
import moment from "moment";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import Sector_path from "@/components/sector_path.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import dayjs from "dayjs";


export default {
  components: {
    SelectedSectorView,
    Sector_path,
    Sector_selection_modal,
    Multiselect, Datepicker
  },
  data() {
    return {
      mediaBase: mediaBase,
      requestType: '',
      requestSubType: '',
      faq: [],
      requestTitle: '',
      requestDescription: '',
      requestIsPrivate: 0,
      requestIsPersonalAllowed: 0,
      onlyVerified: 0,
      onlyVendors: 0,
      requestDeadline: '',
      requestFiles: [],
      requestSectors: [],
      sectors: [],
      uploadProgress: 0,
      products: [],
      photoIndex: 0,
      rfqTerms: 0,
      orderExtras: {
        pickUpCountry: '',
        pickUpCity: '',
        pickUpAddress: '',
        dropOffCountry: '',
        dropOffCity: '',
        dropOffAddress: '',
        deadline: '',
        notes: '',
        incoterms: '',
        types: [],
        loadSize: '',
        loadUnit: '',
        multiSelect: 0,
        ownVariant: 0
      },
      format: "dd MMM yyyy",
      inctermsList: ["EXW", "FOB", "CIF", "FCA", "DPU", "CFR", "CIP", "DAP", "DDP"],
      typeList: deliveryTypes(),
      advTypeList: loadTypes(),
      productUnits: this.$t("productUnits"),
      serviceUnits: this.$t("serviceUnits"),
      loadUnits: this.$t("loadUnits"),
      pollAnswerList: [],

      vendorManagementAvailable: false
    };
  },
  watch: {

    "$route"() {
      this.requestType = this.$route.query.type;
    },
    onlyVerified(newVal) {
      if (newVal) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.onlyVerifiedModalText"),
          icon: 'warning'
        })
      }
    },
    onlyVendors(newVal) {
      if (newVal) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.onlyVendorModalText"),
          icon: 'warning'
        })
      }
    },
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      profile: state => state.auth.profile,
    }),
    nonLogisticSectors() {

      if (this.profile === 'LOGISTIC') {
        return this.sectors.filter(s => s.logistic);
      } else {
        return this.sectors.filter(s => !s.logistic);
      }

    },

    minDeadline() {
      return dayjs().add(1, "day").format("YYYY-MM-D");
    }

  },
  mounted() {

    this.requestType = this.$route.query['type'] || '';

    if (this.requestType === '') {
      this.$router.push({name: 'welcome'});
    } else if (['RFQ', 'PQT', 'PQ', 'AUC', 'REV'].indexOf(this.requestType) > -1) {
      this.addNewProduct();
    } else if (['POL'].indexOf(this.requestType) > -1) {
      this.pollAnswerList.push('');
      this.pollAnswerList.push('');
    }

    getWorkingSectors(this.$i18n.locale).then(data => {
      this.sectors = data;
    })


    getVendorManagementStatus(this.token).then(({code}) => {
      this.vendorManagementAvailable = (code === 200);
    })

  },
  methods: {
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },

    sectorSelected(sectors) {

      console.log("selected");

      this.requestSectors = sectors;
      this.$bvModal.hide('modal-sector-selection');
    },
    createRequest() {
      let sectors = this.requestSectors.map(function (elem) {
        return elem.id;
      }).join(",");
      switch (this.requestType) {
        case "LGI":
        case "LOG":
        case "TRS":
        case "TRK":
          sectors = 13;
          break;
        case "CSI":
          sectors = 14;
          break;
        case "WHI":
          sectors = 12;
          break;
        case "OFR":
          if (this.profile === 'LOGISTIC') {
            sectors = 13;
          }
          break;
      }

      if (this.requestType === 'RFQ' || this.requestType === 'PQT') {

        let lastItem = this.products[this.products.length - 1];

        if (lastItem.name === '' || lastItem.count < 1 || lastItem.unit === '') {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("zhmtOlmsMvcdMhsllTmDldrg"),
            icon: 'warning'
          })

          return;
        }

        if (this.rfqTerms < 1) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("newAUCRequest.qaydalariQebul"),
            icon: 'warning'
          })
          return;
        }
      }

      let extras = {};
      if (this.requestType === 'PQT') {
        let winnerDeadlineFormatted = moment(this.orderExtras.winnerDeadline).format('YYYY-MM-DD HH:mm:ss');

        extras = {
          "version": "1.0.0",
          "currency": this.orderExtras.currency,
          "currencyRequired": this.orderExtras.currencyRequired,
          "incoterms": this.orderExtras.incoterms,
          "incotermsRequired": this.orderExtras.incotermsRequired,
          "payment": this.orderExtras.payment,
          "paymentRequired": this.orderExtras.paymentRequired,
          "deliveryNeeded": this.orderExtras.deliveryNeeded,
          "delivery": `${this.orderExtras.delivery}`,
          "initialRequirementNotes": this.orderExtras.initialRequirementNotes,
          "winnerDeadline": winnerDeadlineFormatted
        };
      } else if (this.requestType === 'AUC') {

        extras = {
          "version": "1.0.0",
          "startingPrice": this.orderExtras.startingPrice
        };
      } else if (this.requestType === 'POL') {

        extras = {
          "version": "1.0.0",
          "multiSelect": this.orderExtras.multiSelect,
          "ownVariant": this.orderExtras.ownVariant
        };
      } else if (this.requestType === 'LOG') {
        let deadlineFormatted = moment(this.requestDeadline).format('YYYY-MM-DD');

        extras = {
          "version": "1.0.0",
          "pickupCountry": this.orderExtras.pickUpCountry,
          "pickupCity": this.orderExtras.pickUpCity,
          "pickupAddress": this.orderExtras.pickUpAddress,
          "dropOffCountry": this.orderExtras.dropOffCountry,
          "dropOffCity": this.orderExtras.dropOffCity,
          "dropOffAddress": this.orderExtras.dropOffAddress,
          "offerDeadline": deadlineFormatted,
          "notes": this.orderExtras.notes,
          "incoterms": this.orderExtras.incoterms,
          "types": this.orderExtras.types.map((t) => {
            return t.key;
          }).join(","),
        };
      } else if (this.requestType === 'TRS') {
        let deadlineFormatted = moment(this.orderExtras.deadline).format('YYYY-MM-DD');

        extras = {
          "version": "1.0.0",
          "pickupCountry": this.orderExtras.pickUpCountry,
          "pickupCity": this.orderExtras.pickUpCity,
          "pickupAddress": this.orderExtras.pickUpAddress,
          "dropOffCountry": this.orderExtras.dropOffCountry,
          "dropOffCity": this.orderExtras.dropOffCity,
          "dropOffAddress": this.orderExtras.dropOffAddress,
          "offerDeadline": deadlineFormatted,
        };
      } else if (this.requestType === 'TRK') {
        let deadlineFormatted = moment(this.orderExtras.deadline).format('YYYY-MM-DD');

        extras = {
          "version": "1.0.0",
          "pickupCountry": this.orderExtras.pickUpCountry,
          "pickupCity": this.orderExtras.pickUpCity,
          "dropOffCountry": this.orderExtras.dropOffCountry,
          "dropOffCity": this.orderExtras.dropOffCity,
          "volume": this.orderExtras.loadSize,
          "unit": this.orderExtras.loadUnit,
          "offerDeadline": deadlineFormatted,
          "types": this.orderExtras.types.map((t) => {
            return t.key;
          }).join(","),
        };
      } else if (this.requestType === 'OFR') {

        if (this.requestSubType === 'wholesale') {
          extras = {
            "version": "1.0.0",
            "minOrder": this.orderExtras.minOrder,
            "unit": this.orderExtras.unit,
            "price": this.orderExtras.price,
            "payment": this.orderExtras.payment,
            "delivery": this.orderExtras.delivery,
          };
        } else if (this.requestSubType === 'retail') {
          extras = {
            "version": "1.0.0",
            "payment": this.orderExtras.payment,
            "delivery": this.orderExtras.delivery,
          };
        } else if (this.requestSubType === 'service') {
          extras = {
            "version": "1.0.0",
            "payment": this.orderExtras.payment,
          };
        }
      }

      if (this.requestType !== 'RFI' && this.requestType !== 'OFR') {
        this.requestSubType = this.requestType;
      }

      if (this.requestTitle !== '' && (['LOG', 'TRS', 'TRK'].indexOf(this.requestType) > -1 || this.requestDescription.length >= 20) && (sectors + "").length > 0) {

        createRequest(
            this.token,
            this.requestType, this.requestSubType,
            sectors,
            this.requestTitle, this.requestFiles, this.requestDescription,
            this.requestDeadline,
            this.requestIsPrivate, this.requestIsPersonalAllowed,
            this.onlyVerified, this.onlyVendors,
            JSON.stringify(extras),
            this.products, this.pollAnswerList
        ).then(data => {

          if (data.code === 200) {

            this.$router.replace('/dashboard/request/' + data.id);

          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }

        })

      } else if (sectors.length < 1) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("generalModal.noWorkingSectorWarning"),
          icon: 'error'
        })
      } else if (['LOG', 'TRS', 'TRK'].indexOf(this.requestType) === -1 && this.requestDescription.length < 20) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.soruSpesifikasiyasNAz20SimvoldanIbartOlmaldr"),
          icon: 'error'
        })
      } else {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.butunBolmeleri"),
          icon: 'error'
        })
      }

    },

    getPhoto(path, size) {
      return getPhoto(path, size);
    },

    selectExcel() {
      window.document.getElementById('excelInput').click();
    },


    setExcel() {
      let currentFile = this.$refs.excelFile.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'excel', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {


                createRequestFromExcel(this.token, response.data.path).then(data => {

                  if (data.code === 200) {
                    this.requestTitle = data.data.title;
                    this.requestDescription = data.data.description;
                    this.requestDeadline = data.data.deadline;
                    this.requestIsPrivate = data.data.private ? 1 : 0;
                    this.products = [];
                    data.data.products.forEach(p => {
                      this.products.push({
                        productType: p.type,
                        name: p.name,
                        note: p.description,
                        count: parseInt(p.count),
                        unit: p.unit,
                        photo: ''
                      });
                    });

                    this.$swal({
                      title: this.$t("generalModal.successTitle"),
                      text: this.$t("newAUCRequest.melumatlarKocuruldu"),
                      icon: 'success'
                    })


                  } else {
                    this.$swal({
                      title: `Error ${data.code}`,
                      text: `${data.message}`,
                      icon: 'error'
                    })
                  }

                })


              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {
              console.log(e);
              this.progress = 0;
              this.$swal({
                title: `Error`,
                text:  this.$t("cldNotUploadFile") + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    },
    selectPhoto(index) {
      this.photoIndex = index;
      window.document.getElementById('fileInput').click();
    },

    deleteFile(index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.requestFiles.splice(index, 1);
      }
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'requestPhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {

                if (['RFQ', 'PQT', 'REV', 'AUC'].indexOf(this.requestType) > -1) {
                  this.products[this.photoIndex].photo = response.data.path;
                } else {

                  this.requestFiles.push({
                    id: 0,
                    path: response.data.path,
                    type: "request"
                  });

                }

              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {
              console.log(e);
              this.progress = 0;
              this.$swal({
                title: `Error`,
                text:  this.$t("cldNotUploadFile") + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    },

    addNewProduct() {

      if (this.products.length > 0) {

        let lastItem = this.products[this.products.length - 1];

        if (lastItem.name === '' || lastItem.count < 1 || lastItem.unit === '') {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("zhmtOlmsMvcdMhsllTmDldrg"),
            icon: 'warning'
          })
          return;
        }
      }

      this.products.push({
        name: '',
        note: '',
        count: '',
        unit: '',
        photo: ''
      })
    },
    deleteProduct(index) {
      this.products.splice(index, 1)
    },
    deleteVariant(index) {
      this.pollAnswerList.splice(index, 1)
    }
  }
}
</script>
